module.exports = __webpack_public_path__ + "static/Light-Yellow-eb4b1415a16ea1e0f49ab7b6f041525e.png";